function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconCompanyMember = function IconCompanyMember(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45",
    height: "100",
    viewBox: "0 0 45 100",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3732_10796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24.9997C28.7132 24.9997 33.75 19.9121 33.75 13.6361C33.75 7.36013 28.7132 2.27246 22.5 2.27246C16.2868 2.27246 11.25 7.36013 11.25 13.6361C11.25 19.9121 16.2868 24.9997 22.5 24.9997Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 99.9999V81.8181C39.735 81.8181 42.75 78.7726 42.75 74.9999V47.7272C42.75 40.2045 36.6975 34.0908 29.25 34.0908H15.75C8.3025 34.0908 2.25 40.2045 2.25 47.7272V74.9999C2.25 78.7726 5.265 81.8181 9 81.8181V99.9999",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3732_10796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "45",
    height: "100",
    fill: "white"
  }))));
};